// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-payroll-container {
  padding: 14px;
  background-color: #f8fafc;
  /* min-height: 100vh; */
  /* font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; */
}

.confirm-header {
  margin-bottom: 12px;
}

.confirm-header h2 {
  margin: 0 0 8px 0;
  color: #1e293b;
  font-size: 24px;
}

.confirm-header p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

/* Table Card Styling */
.comparison-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 24px;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
}

.comparison-table th, 
.comparison-table td {
  padding: 10px 15px;
  border-bottom: 1px solid #e2e8f0;
}

.comparison-table th {
  background-color: #f1f5f9;
  color: #475569;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.comparison-table tbody tr:last-child td {
  border-bottom: none;
}

.comparison-table tbody tr:hover {
  background-color: #f8fafc;
}

/* Text Utilities */
.text-right { text-align: right; }
.font-medium { font-weight: 500; color: #334155; }
.font-bold { font-weight: 600; }
.text-muted { color: #94a3b8; }

/* Dynamic Difference Colors */
.text-green { color: #10b981; } /* Success green */
.text-red { color: #ef4444; }   /* Danger red */
.text-gray { color: #64748b; }  /* Neutral */

/* Footer & Buttons */
.action-footer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #334155;
  border: 1px solid #cbd5e1;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.download-btn:hover {
  background-color: #f1f5f9;
  border-color: #94a3b8;
}

.download-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.excel-adjust-btn {
  min-width: 140px;
}

.excel-adjust-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
}

.excel-adjust-modal {
  width: min(100%, 800px);
  max-height: 80vh;
  overflow-y: auto;
  background: #fafafa;
  border-radius: 12px;
  border: 1px solid #dbe4ee;
  padding: 18px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
}

.excel-adjust-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.excel-adjust-topbar h3 {
  margin: 0;
  font-size: 20px;
  color: #1e293b;
}

.excel-adjust-back-btn,
.excel-adjust-close-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #334155;
}

.excel-adjust-back-btn:hover,
.excel-adjust-close-btn:hover {
  background: #e2e8f0;
}

.excel-adjust-close-btn {
  font-size: 26px;
}

.excel-adjust-saved-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.excel-adjust-saved-header h4 {
  margin: 0;
  color: #2c3e50;
}

.excel-adjust-saved-view{
  display: flex;
  justify-content: center;
}

.excel-adjust-add-text-btn,
.submit-template-btn {
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

/* .excel-adjust-add-text-btn {
  background: #deecdd;
  color: #2f5c2d;
  padding: 8px 16px;
} */

.excel-adjust-selector-view {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.excel-adjust-table {
  flex: 1 1 320px;
  border: 1px solid #b5b5b5;
  border-radius: 8px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.excel-adjust-table.single-table {
  max-width: 60%;
}

.excel-adjust-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
}

.excel-adjust-table th {
  position: sticky;
  top: 0;
  background: #deecdd;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #2c3e50;
  border-bottom: 1px solid #ccc;
}

.excel-adjust-header-cell {
  position: relative;
  text-align: center;
}

.excel-adjust-header-cell span {
  display: block;
  width: 100%;
}

.excel-adjust-table tbody tr:nth-child(odd) {
  background: #f4f4f4;
}

.excel-adjust-table td {
  padding: 8px 10px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  vertical-align: middle;
}

.excel-adjust-selector-view .excel-adjust-table:first-child td:first-child {
  cursor: pointer;
}

.excel-adjust-add-text-btn {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 4px 10px;
  border: none;
  border-radius: 4px;
  color: black;
  background: #05cc7968;
}

.excel-adjust-table button:hover {
  background: #d3dbe0;
}
.excel-adjust-remove-btn{
   cursor: pointer;
  padding: 4px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color:red;
}
.excel-adjust-remove-btn :hover {
  background: #d3dbe0;
}
.excel-adjust-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.submit-template-btn {
  background: rgb(132, 199, 174);
  color: #fff;
  padding: 10px 22px;
}

.submit-template-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .excel-adjust-modal {
    padding: 14px;
  }

  .excel-adjust-topbar h3 {
    font-size: 18px;
  }

  .excel-adjust-selector-view {
    flex-direction: column;
  }
}

.confirm-btn {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.confirm-btn:hover {
  background-color: #1d4ed8;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/PayRole/ConfirmPayroll/ConfirmPayroll.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,sGAAsG;AACxG;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB,cAAc,iBAAiB,EAAE;AACjC,eAAe,gBAAgB,EAAE,cAAc,EAAE;AACjD,aAAa,gBAAgB,EAAE;AAC/B,cAAc,cAAc,EAAE;;AAE9B,8BAA8B;AAC9B,cAAc,cAAc,EAAE,EAAE,kBAAkB;AAClD,YAAY,cAAc,EAAE,IAAI,eAAe;AAC/C,aAAa,cAAc,EAAE,GAAG,YAAY;;AAE5C,qBAAqB;AACrB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;AACA;GACG,eAAe;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".confirm-payroll-container {\n  padding: 14px;\n  background-color: #f8fafc;\n  /* min-height: 100vh; */\n  /* font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif; */\n}\n\n.confirm-header {\n  margin-bottom: 12px;\n}\n\n.confirm-header h2 {\n  margin: 0 0 8px 0;\n  color: #1e293b;\n  font-size: 24px;\n}\n\n.confirm-header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* Table Card Styling */\n.comparison-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n.comparison-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.comparison-table th, \n.comparison-table td {\n  padding: 10px 15px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.comparison-table th {\n  background-color: #f1f5f9;\n  color: #475569;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.comparison-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.comparison-table tbody tr:hover {\n  background-color: #f8fafc;\n}\n\n/* Text Utilities */\n.text-right { text-align: right; }\n.font-medium { font-weight: 500; color: #334155; }\n.font-bold { font-weight: 600; }\n.text-muted { color: #94a3b8; }\n\n/* Dynamic Difference Colors */\n.text-green { color: #10b981; } /* Success green */\n.text-red { color: #ef4444; }   /* Danger red */\n.text-gray { color: #64748b; }  /* Neutral */\n\n/* Footer & Buttons */\n.action-footer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.download-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  color: #334155;\n  border: 1px solid #cbd5e1;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.download-btn:hover {\n  background-color: #f1f5f9;\n  border-color: #94a3b8;\n}\n\n.download-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.excel-adjust-btn {\n  min-width: 140px;\n}\n\n.excel-adjust-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n  padding: 20px;\n}\n\n.excel-adjust-modal {\n  width: min(100%, 800px);\n  max-height: 80vh;\n  overflow-y: auto;\n  background: #fafafa;\n  border-radius: 12px;\n  border: 1px solid #dbe4ee;\n  padding: 18px;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);\n}\n\n.excel-adjust-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.excel-adjust-topbar h3 {\n  margin: 0;\n  font-size: 20px;\n  color: #1e293b;\n}\n\n.excel-adjust-back-btn,\n.excel-adjust-close-btn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #334155;\n}\n\n.excel-adjust-back-btn:hover,\n.excel-adjust-close-btn:hover {\n  background: #e2e8f0;\n}\n\n.excel-adjust-close-btn {\n  font-size: 26px;\n}\n\n.excel-adjust-saved-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.excel-adjust-saved-header h4 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.excel-adjust-saved-view{\n  display: flex;\n  justify-content: center;\n}\n\n.excel-adjust-add-text-btn,\n.submit-template-btn {\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n/* .excel-adjust-add-text-btn {\n  background: #deecdd;\n  color: #2f5c2d;\n  padding: 8px 16px;\n} */\n\n.excel-adjust-selector-view {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.excel-adjust-table {\n  flex: 1 1 320px;\n  border: 1px solid #b5b5b5;\n  border-radius: 8px;\n  max-height: 320px;\n  overflow-y: auto;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.excel-adjust-table.single-table {\n  max-width: 60%;\n}\n\n.excel-adjust-table table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 5px;\n}\n\n.excel-adjust-table th {\n  position: sticky;\n  top: 0;\n  background: #deecdd;\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #2c3e50;\n  border-bottom: 1px solid #ccc;\n}\n\n.excel-adjust-header-cell {\n  position: relative;\n  text-align: center;\n}\n\n.excel-adjust-header-cell span {\n  display: block;\n  width: 100%;\n}\n\n.excel-adjust-table tbody tr:nth-child(odd) {\n  background: #f4f4f4;\n}\n\n.excel-adjust-table td {\n  padding: 8px 10px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n  vertical-align: middle;\n}\n\n.excel-adjust-selector-view .excel-adjust-table:first-child td:first-child {\n  cursor: pointer;\n}\n\n.excel-adjust-add-text-btn {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  cursor: pointer;\n  padding: 4px 10px;\n  border: none;\n  border-radius: 4px;\n  color: black;\n  background: #05cc7968;\n}\n\n.excel-adjust-table button:hover {\n  background: #d3dbe0;\n}\n.excel-adjust-remove-btn{\n   cursor: pointer;\n  padding: 4px 10px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color:red;\n}\n.excel-adjust-remove-btn :hover {\n  background: #d3dbe0;\n}\n.excel-adjust-footer {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.submit-template-btn {\n  background: rgb(132, 199, 174);\n  color: #fff;\n  padding: 10px 22px;\n}\n\n.submit-template-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .excel-adjust-modal {\n    padding: 14px;\n  }\n\n  .excel-adjust-topbar h3 {\n    font-size: 18px;\n  }\n\n  .excel-adjust-selector-view {\n    flex-direction: column;\n  }\n}\n\n.confirm-btn {\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.confirm-btn:hover {\n  background-color: #1d4ed8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
